import { render } from "./ComplianceHealthDashboard.vue?vue&type=template&id=07ae66d9&scoped=true"
import script from "./ComplianceHealthDashboard.vue?vue&type=script&lang=js"
export * from "./ComplianceHealthDashboard.vue?vue&type=script&lang=js"

import "./ComplianceHealthDashboard.vue?vue&type=style&index=0&id=07ae66d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ae66d9"]])

export default __exports__